<template>
  <Select v-if="showFlag" :value="value" @on-change="onChange" :style="{ width: width + 'px' }" :multiple="multiple" :placeholder="placeholder" clearable :transfer="true" :disabled="disabled" :size="size" filterable>
    <Option v-for="item in list" :value="item.code" :key="item.code">{{ item.text }}</Option>
  </Select>
  <!-- 使用组件 -->
  <!-- <dict-select :exclusion=[] namespace="bizObjects" id="EOAProcessSpace" v-model="" /> -->
</template>
<script>
export default {
  model: {
    prop: "value",
    event: "on-change",
  },
  props: {
    value: "",
    namespace: {
      type: String,
      default: "default",
    },
    id: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 200,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    exclusion: {
      type: Array,
      default: () => [],
    },
    includes: {
      type: Array,
      default: () => [],
    },
    size: {
      type: String,
      default: "default",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showFlag: false,
      list: [],
    };
  },
  async mounted() {
    let queryParams = {
      body: { namespace: this.namespace, type: this.id },
      url: "CORE-COMMON/messageService/dictService/queryEntries",
    };

    let dictList = await this.invoke(queryParams);

    if (this.includes.length) {
      this.list = this.includes.length
        ? dictList.filter(({ code }) => this.includes.includes(code))
        : dictList;
    } else {
      this.list = this.exclusion.length
        ? dictList.filter(({ code }) => !this.exclusion.includes(code))
        : dictList;
    }

    this.showFlag = true;
  },
  methods: {
    onChange(value) {
      this.$emit("on-change", value);
    },
  },
};
</script>